<template>
  <v-container fluid class="mt-5 pl-6 pr-6">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-body-1">Kpi Metas</span>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportar()"
              tile
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn 
              color="primary" 
              @click="consultar()" 
              small
              tile
            >
              Consultar
            </v-btn>
          </v-card-title>

          <v-card-text>

            <v-row>
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="resultadoInbi"
              sort-by="calories"
              class="elevation-0 mt-4"
              hide-default-footer
              :items-per-page="50"
              dense
              mobile-breakpoint="200"
              id="kpiMetas"
              v-if="verInbi"
            >
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                  small
                >
                  Actualizar
                </v-btn>
              </template>
            </v-data-table>

            <v-data-table
              :headers="headersFast"
              :items="resultadoFast"
              sort-by="calories"
              class="elevation-0 mt-4"
              hide-default-footer
              :items-per-page="50"
              dense
              mobile-breakpoint="200"
              v-if="verFast"
              id="kpiMetas2"
            >
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                  small
                >
                  Actualizar
                </v-btn>
              </template>
            </v-data-table>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';

  import { mapGetters } from 'vuex'

  import XLSX from 'xlsx'
  // Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';


  export default {
    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      snackbar:false,
      headers: [
        { text: 'Plantel'          , value: 'plantel' },
        { text: 'Estado'           , value: 'ciudad' },
        { text: 'Meta alum'        , value: 'metas_alumnos' },
        { text: 'Meta $'           , value: 'meta_monto', align: 'right'    },
        { text: 'Avance Al'        , value: 'avance_alumnos' },
        { text: 'Avance $'         , value: 'avance_monto', align: 'right' },

        { text: 'T Meta alum'      , value: 'teens_metas_alumnos' },
        { text: 'T Meta $'         , value: 'teens_meta_monto', align: 'right'    },
        { text: 'T Avance Al'      , value: 'teens_avance_alumnos' },
        { text: 'T Avance $'       , value: 'teens_avance_monto', align: 'right' },

        { text: 'P Meta alum'      , value: 'presencial_metas_alumnos' },
        { text: 'P Meta $'         , value: 'presencial_meta_monto', align: 'right'    },
        { text: 'P Avance Al'      , value: 'presencial_avance_alumnos' },
        { text: 'P Avance $'       , value: 'presencial_avance_monto', align: 'right' },

        { text: 'O Meta alum'      , value: 'online_metas_alumnos' },
        { text: 'O Meta $'         , value: 'online_meta_monto', align: 'right'    },
        { text: 'O Avance Al'      , value: 'online_avance_alumnos' },
        { text: 'O Avance $'       , value: 'online_avance_monto', align: 'right' },
      ],

      headersFast: [
        { text: 'Plantel'          , value: 'plantel' },
        { text: 'Estado'           , value: 'ciudad' },
        { text: 'Meta alum'        , value: 'fast_metas_alumnos' },
        { text: 'Meta $'           , value: 'fast_meta_monto', align: 'right'    },
        { text: 'Avance Al'        , value: 'avance_alumnos' },
        { text: 'Avance $'         , value: 'avance_monto', align: 'right' },

        { text: 'P Meta alum'      , value: 'fast_presencial_metas_alumnos' },
        { text: 'P Meta $'         , value: 'fast_presencial_meta_monto', align: 'right'    },
        { text: 'P Avance Al'      , value: 'fast_presencial_avance_alumnos' },
        { text: 'P Avance $'       , value: 'fast_presencial_avance_monto', align: 'right' },

        { text: 'O Meta alum'      , value: 'fast_online_metas_alumnos' },
        { text: 'O Meta $'         , value: 'fast_online_meta_monto', align: 'right'    },
        { text: 'O Avance Al'      , value: 'fast_online_avance_alumnos' },
        { text: 'O Avance $'       , value: 'fast_online_avance_monto', align: 'right' },
      ],

      resultadoInbi:[],
      resultadoFast:[],
      ciclo: null,
      ciclos:[],

      verInbi: false,
      verFast: false,

    }),

    watch: {
      ciclo ( val ) {
        if( val ){ this.consultar() }
      }
    },

    computed: {
      ...mapGetters( 'login' , ['getdatosUsuarioERPERP'] ),
    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize( ){
        this.cargar = true
        this.$http.get('kpi.ciclos.all').then(response=>{
          this.ciclos = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async consultar () {
        this.cargar  = true
        this.verInbi = false
        this.verFast = false
        return this.$http.post('kpi.metas', this.ciclo ).then(response=>{
          this.resultadoInbi = response.data.inbi
          this.resultadoFast = response.data.fast
          this.consultarAvances( )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async consultarAvances () {
        this.cargar = true

        this.$http.post('kpi.inscripciones.general', this.ciclo ).then(response=>{

          this.dataTablaFastDos = response.data.fast
          this.dataTablaInbiDos = response.data.inbi

          for( const i in this.resultadoInbi ){

            const { plantel } = this.resultadoInbi[i]

            let pagosPlantel = this.dataTablaInbiDos.filter( el => el.plantel == plantel )

            let gruposTeens = pagosPlantel.filter( el => el.grupo.match('TEENS') && !el.grupo.match('ONLINE') )
            let gruposPInbi = pagosPlantel.filter( el => !el.grupo.match('TEENS') && !el.grupo.match('ONLINE') )
            let gruposOInbi = pagosPlantel.filter( el => el.grupo.match('ONLINE') )
 
            let meta_monto                 = pagosPlantel.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)
            let teens_meta_monto           = gruposTeens.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)
            let presencial_meta_monto      = gruposPInbi.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)
            let online_meta_monto          = gruposOInbi.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)  

            this.resultadoInbi[i]['avance_alumnos']            = pagosPlantel.length
            this.resultadoInbi[i]['teens_avance_alumnos']      = gruposTeens.length
            this.resultadoInbi[i]['presencial_avance_alumnos'] = gruposPInbi.length
            this.resultadoInbi[i]['online_avance_alumnos']     = gruposOInbi.length

            this.resultadoInbi[i]['avance_monto'] = this.format( meta_monto )
            this.resultadoInbi[i]['teens_avance_monto'] = this.format( teens_meta_monto )
            this.resultadoInbi[i]['presencial_avance_monto'] = this.format( presencial_meta_monto )
            this.resultadoInbi[i]['online_avance_monto'] = this.format( online_meta_monto )

          }

          for( const i in this.resultadoFast ){

            const { plantel } = this.resultadoFast[i]

            let pagosPlantel = this.dataTablaFastDos.filter( el => el.plantel == plantel )

            let gruposPFast = pagosPlantel.filter( el => !el.grupo.match('ONLINE') )
            let gruposOFast = pagosPlantel.filter( el => el.grupo.match('ONLINE') )
 
            let meta_monto                 = pagosPlantel.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)
            let presencial_meta_monto      = gruposPFast.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)
            let online_meta_monto          = gruposOFast.map(item => item.pagado ).reduce((prev, curr) => prev + curr, 0)  

            this.resultadoFast[i]['avance_alumnos'] = pagosPlantel.length
            this.resultadoFast[i]['fast_presencial_avance_alumnos'] = gruposPFast.length
            this.resultadoFast[i]['fast_online_avance_alumnos'] = gruposOFast.length

            this.resultadoFast[i]['avance_monto']                 = this.format( meta_monto )
            this.resultadoFast[i]['fast_presencial_avance_monto'] = this.format( presencial_meta_monto )
            this.resultadoFast[i]['fast_online_avance_monto']     = this.format( online_meta_monto )

          }

          this.verInbi = true
          this.verFast = true

          console.log( this.dataTablaFastDos, this.dataTablaInbiDos )

          this.cargar = false
        }).catch( error =>{

          console.log( error)
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      format( valor ){
        return valor.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        });
      }

    },
  }
</script>
<style scoped>

  
  #kpiMetas td:nth-child(4) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas td:nth-child(5) {
    background-color: #E8E8E8 !important;
  }
  #kpiMetas td:nth-child(6) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas td:nth-child(7) {
    background-color: #E8E8E8 !important;
  }



  #kpiMetas td:nth-child(13) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas td:nth-child(14) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas td:nth-child(15) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas td:nth-child(16) {
    background-color: #E8E8E8 !important;
  }



  #kpiMetas2 td:nth-child(2) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(3) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(4) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(5) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(13) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(14) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(15) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas2 td:nth-child(16) {
    background-color: #E8E8E8 !important;
  }



  #kpiMetas3 td:nth-child(2) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(3) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(4) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(5) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(13) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(14) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(15) {
    background-color: #E8E8E8 !important;
  }

  #kpiMetas3 td:nth-child(16) {
    background-color: #E8E8E8 !important;
  }


</style>